import { Component, ViewChild, TemplateRef, Input, Output, OnInit, ElementRef, EventEmitter } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { ViewportScroller } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { DocumentViewerPrinterComponent } from 'src/app/support/document-viewer-printer/document-viewer-printer.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-document-download-template-vw',
  templateUrl: './document-download-template.component.html',
  styleUrls: ['./document-download-template.component.scss']
})
export class DocumentDownloadTemplateComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  documentDownloadTemplateDataForGrid: any = [];
  documentDownloadTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  organizationReportImageDetails: any = {};

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddRepeatIntervalUnit: any = null;

  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    disableClose: true,
    height: 'auto',
    hasBackdrop: true,
    position: { top: '30px' },
  };


  constructor(readonly _formBuilder: FormBuilder, public appService: AppService, readonly router: Router, public dialog: MatDialog,
    readonly scroller: ViewportScroller, readonly snackBar: MatSnackBar, readonly activatedRoute: ActivatedRoute, readonly elem: ElementRef,
    public message: messageService, public paginationService: PaginationService, readonly authService: MsalService) {

  }
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';

  documentIssuanceTypeAddDropdown: {
    valueExp: string;
    displayExp: string;
    isChecked: boolean;
    title: string;
  }[] = [];

  documentIssuanceTypeIncludeDropdown: {
    valueExp: string;
    displayExp: string;
    isChecked?: boolean;
    title?: string;
  }[] = [];

  documentIssuanceAddType: any;
  documentIssuanceTypeAddList: any = ["Cover page / Sign", "Revision history", "Amendment", "Approval"];
  documentIssuanceTypeIncludeList: any = ["Footer", "Page Number", "Publisher details", "Linked documents", "Notes"];
  documentIssuanceType: any = null;
  documentIssuanceIncludeType: any = "Revision History";
  typeDmsDocumentsVw: { documentId: any; version: any; };
  issuanceReason: any;
  issuanceTo: any;
  issuanceCopy: any;
  reportLogoDropdown: any = [];
  typeDmsDocumentsVwaterMark: { documentId: any; version: any; printParentDetails: string; documentTypeCode: any; sessionUserId: string | null; issuanceReason: any; issuanceTo: any; noOfCopy: any; };
  incudeCoverPgae: any = false;
  incudeCoverPgaeTitle: any;
  incudeRevisionhistory: any = false;
  incudeRevisionhistoryTitle: any;
  incudeFooter: any = false;
  incudeFooterTitle: any;
  incudeAmendmentTitle: any;
  incudeAmendment: any = false;
  incudeApproval: any = false;
  incudeApprovalTitle: any;
  dropDownDataForReportLogo: any;
  selectedIssuanceValue: any;
  onLastPage: boolean;
  incudePageNo: any = false;
  publisherDetails: any = false;
  linkedDocuments: any;
  incudeNotes: any = false;
  incudeNotesTitle: any;
  documentWatermark: any;
  documentNameForDownload: any;
  historyYear: any = null;
  isLatestOnTop: boolean = true;
  watermarkColor: any;

  documentIssuanceSelect(event: any, item: any): void {
    if (!event?.isUserInput) return;

    this.documentIssuanceType = item?.valueExp ?? null;
  }

  selectedReportLogoValue: any = null;
  selectedHeaderTemplate: any = null;
  isShowOnLatestTopDisabled: boolean = false;
  onReportLogoValueSelect(event: any, item: any): void {
    if (event?.isUserInput) {
      const value = item?.valueExp ?? null;
      this.selectedReportLogoValue = value;
      this.documentDownloadTemplateFieldData.reportLogoId = value;
    }
  }


  onHeaderTemplateSelect(event: any, item: any): void {
    if (event?.isUserInput) {
      this.selectedHeaderTemplate = item?.valueExp ?? null;
    }
  }

  checkBoxisLatestOnTop(event: any): void {
    this.isLatestOnTop = event.checked;
  }

  pdfDetailSearchText: string = '';
  toggleChanged(event: any): void {
    if (event.checked) {
      this.isShowOnLatestTopDisabled = true;
      this.onLastPage = true;
    } else {
      this.isShowOnLatestTopDisabled = false;
    }
  }

  onApprovalToggleChanged(event: any): void {
    if (event.checked) {
      this.onLastPage = true;
    }
  }


  validateYear(event: KeyboardEvent): void {
    const blockedKeys = ['e', 'E', '+', '-', '.'];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onNotesChange(value: string): void {
    if (value.length > 75) {
      this.incudeNotesTitle = value.substring(0, 75);
    }
  }


  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentDownloadTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentDownloadTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.documentDownloadTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.documentDownloadTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.documentDownloadTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }


  getcallMethod(): void {


    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

    this.documentDownloadTemplateDataForGrid = [];

    const data = {
      gridName: 'DOCUMENT_DOWNLOAD_TEMPLATE'
    };

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= '';
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {
          gridName: 'DMS_DOCUMENT_DOWNLOAD_TEMPLATE_VW',
          tableOrViewName: response.tableOrViewName ?? '',
          columnsList: response.columnsList ?? '',
          fieldLabelsList: response.fieldLabelsList ?? '',
          invisibleColumn: response.invisibleColumn ?? '',
          orderByClause: response.orderByClause ?? '',
          fieldSizeList: response.fieldSizeList ?? '',
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? '',
          blobColumnlist: response.bloblist ?? ''
        };

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentDownloadTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(',').map((s: string) => s.trim());
            data1.fieldColumnarray = data1.fieldLabelsList.split(',').map((s: string) => s.trim());
            data1.invisibleColumnarray = data1.invisibleColumn.split(',').map((s: string) => s.trim());
            data1.fieldSizeListArray = data1.fieldSizeList.split(',').map((s: string) => s.trim());

            this.columnLists.columnsListarray = [...data1.columnsListarray];
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                fieldColumnarray: data1.fieldColumnarray[p],
                width: data1.fieldSizeListArray[p] + 'px'
              });
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let i = this.columnLists.columnsListarray.length - 1; i >= 0; i--) {
              const currentColumn = this.columnLists.columnsListarray[i];
              const isInvisible = this.columnLists.invisibleColumnarray.some(
                (inv: string) => inv.trim().toLowerCase() === currentColumn.trim().toLowerCase()
              );
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(i, 1);
                this.columnLists.fieldColumnarray.splice(i, 1);
                this.columnLists.fieldSizeListArray.splice(i, 1);
              }
            }
            const tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({
                    columnsListarray: this.columnLists.columnsListarray[m],
                    dataType: 'textbox',
                    width: this.columnLists.fieldSizeListArray[m]
                  });

                  for (const type of this.dataTypeList) {
                    if (type.columnName.trim() === this.columnLists.columnsListarray[m].trim()) {
                      this.columnLists.columnsListarray1[m].dataType = type.fieldType;
                    }
                  }
                }

                for (const row of this.documentDownloadTemplateDataForGrid) {
                  for (const type of this.dataTypeList) {
                    if (type.fieldType === 'CHECKBOX') {
                      row[type.columnName] = row[type.columnName] === 'Y';
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.setPage(1, 0);
                this.pager.totalPages = undefined;
              },
              error: (error) => {
                throw error;
              }
            });
            this.message.gridList = this.documentDownloadTemplateDataForGrid;
            this.collectionSize = this.documentDownloadTemplateDataForGrid.length;
            this.totalPages = Math.ceil(
              this.documentDownloadTemplateDataForGrid.length / this.itemsPerPage
            );
            this.DynamicLabelCall();
          },
          error: (error) => {
            throw error;
          }
        });
      },
      error: (error) => {
        throw error;
      }
    });
  }


  getListOfQaUsersFromUserPrivs: any = [];
  dropDownDataForRepeatIntervalUnit: any = [];


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentDownloadTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentDownloadTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.documentDownloadTemplateDataForGridTemp = this.documentDownloadTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.documentDownloadTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.documentDownloadTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.documentDownloadTemplateDataForGrid == undefined) {
        return this.documentDownloadTemplateDataForGrid;
      }
      if (!this.documentDownloadTemplateDataForGrid.length) {
        return this.documentDownloadTemplateDataForGrid;
      }
      if (filter !== undefined && filter !== null) {
        this.documentDownloadTemplateDataForGridTemp = this.documentDownloadTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.documentDownloadTemplateDataForGridTemp = this.documentDownloadTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentDownloadTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    if (isChecked) {
      this.childCheckBoxs = true;
      for (const row of this.documentDownloadTemplateDataForGrid) {
        row.childCheckBoxs = isChecked;
      }
    } else {
      this.childCheckBoxs = false;
      for (const row of this.documentDownloadTemplateDataForGrid) {
        row.childCheckBoxs = isChecked;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.documentDownloadTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.documentDownloadTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  templateName: any;
  templateNameRequiredMsg: any;
  listOfQAUser: any;
  listOfQAUserRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;
  notefield: any;
  noteReqMsg: any;

  fieldValidation() {
    this.templateName = document.getElementById('templateName') as HTMLInputElement;
    this.updateReq = document.getElementById('update') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;
    this.notefield = document.getElementById('notesDetail') as HTMLInputElement;
    this.noteReqMsg = document.getElementById('notes-required-msg') as HTMLInputElement;
    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;

    if (this.documentDownloadTemplateFieldData.templateName === null ||
      this.documentDownloadTemplateFieldData.templateName === undefined ||
      this.documentDownloadTemplateFieldData.templateName === '') {
      this.templateName.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateName.style.border = '1px solid black';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (this.documentDownloadTemplateFieldData.updateReason === null ||
        this.documentDownloadTemplateFieldData.updateReason === undefined ||
        this.documentDownloadTemplateFieldData.updateReason === '') {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      } else {
        this.updateReq.style.border = '1px solid black';
        this.updateReqMsg.style.display = 'none';
      }
    }
    if (this.documentDownloadTemplateFieldData.notes) {
      if (this.documentDownloadTemplateFieldData.notesDetail === null ||
        this.documentDownloadTemplateFieldData.notesDetail === undefined ||
        this.documentDownloadTemplateFieldData.notesDetail === '') {
        this.notefield.style.border = '1px solid red';
        this.noteReqMsg.style.display = 'block';
      } else {
        this.notefield.style.border = '1px solid black';
        this.noteReqMsg.style.display = 'none';
      }
    }
  }

  onFieldFocusout() {
    if (this.updateReqMsg != undefined) {
      this.updateReq.style.border = 'none';
      this.updateReqMsg.style.display = 'none';
    }
    if (this.templateNameRequiredMsg != undefined) {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }


  documentDownloadTemplateFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '20px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  selectedRepeatIntervalUnit: any = null;
  selectedRepeatIntervalUnitDisplayExp: any = null;
  selectedRepeatIntervalUnitValueExp: any = null;
  repeatIntervalUnitDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  onFieldChange() {
    this.fieldValidation()
  }

  selectBoxForRepeatIntervalUnit() {
    for (const item of this.dropDownDataForRepeatIntervalUnit) {
      this.repeatIntervalUnitDropdown = this.repeatIntervalUnitDropdown.concat({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }

  }
  onNotesToggle(event: any): void {
    if (!event.checked) {
      this.documentDownloadTemplateFieldData.notesDetail = null;
    }
  }


  onRevisionHistoryToggle(event: any): void {
    if (event.checked) {
      // 🔹 Default behavior
      this.documentDownloadTemplateFieldData.completeHistory = true;

      // Reset year-based options
      this.documentDownloadTemplateFieldData.totalYears = null;
      this.documentDownloadTemplateFieldData.isLatestOnTop = false;
    } else {
      // 🔹 Reset everything when Revision History is OFF
      this.documentDownloadTemplateFieldData.completeHistory = false;
      this.documentDownloadTemplateFieldData.totalYears = null;
      this.documentDownloadTemplateFieldData.isLatestOnTop = false;
      this.documentDownloadTemplateFieldData.revisionHistoryPageName = null;
    }
  }

  repeatIntervalUnitTxt: any;
  onRepeatIntervalUnitSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedRepeatIntervalUnitDisplayExp = item.displayExp;
        } else {
          this.selectedRepeatIntervalUnitDisplayExp = null;
        }
      } else {
        this.selectedRepeatIntervalUnitDisplayExp = undefined;
      }
    }
  }
  onRepeatIntervalUnitRemoved(item: any) { }




  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup(): void {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = 'Add Document Download Template';
    this.documentDownloadTemplateFieldData = {
      templateName: null,
      issuanceType: null,
      issuedTo: null,
      printsTaken: null,
      issuanceReason: null,
      reportLogoId: null,
      headerTemplate: null,
      comments: null,
      coverPageOrSign: false,
      coverPageOrSignPageName: null,
      revisionHistory: false,
      revisionHistoryPageName: null,
      completeHistory: false,
      totalYears: null,
      isLatestOnTop: false,
      amendment: false,
      amendmentPageName: null,
      approval: false,
      approvalPageName: null,
      onLastPage: false,
      footer: false,
      pageNumber: false,
      publisherDetails: false,
      linkedDocuments: false,
      notes: false,
      notesDetail: null,
      updateReason: null,
      deleteReason: null
    };

    this.visibleAddAndEditPopup = this.dialog.open(
      this.addAndEditPopup,
      this.addAndEditPopupConfig
    );

    this.isProcessing = false;
  }


  openEditPopup(row: any, editFlag: boolean): void {


    this.operationFlag = 'EDIT';
    this.visibleAddButton = false;
    this.visibleEditButton = editFlag;
    this.visibleReasonForUpdateField = true;
    this.previousData = row;

    this.popupDataTitle.title = 'Update Document Download Template';

    this.appService.getDmsDocumentDownloadTemplateVwDetailsByTemplateId(row.TEMPLATE_ID).subscribe((res: any) => {
      this.resetForm();

      /* 🔹 BASIC */
      this.documentDownloadTemplateFieldData.templateId = res.templateId;
      this.documentDownloadTemplateFieldData.templateName = res.templateName;
      this.documentDownloadTemplateFieldData.issuanceType = res.issuanceType;
      this.documentDownloadTemplateFieldData.issuedTo = res.issuedTo;
      this.documentDownloadTemplateFieldData.printsTaken = res.printsTaken;
      this.documentDownloadTemplateFieldData.issuanceReason = res.issuanceReason;
      this.documentDownloadTemplateFieldData.comments = res.comments;
      this.editReportLogoId = res.reportLogoId;
      this.documentDownloadTemplateFieldData.headerTemplate = res.headerTemplate;
      this.documentDownloadTemplateFieldData.coverPageOrSign = res.coverPageOrSign === 'Y';
      this.documentDownloadTemplateFieldData.revisionHistory = res.revisionHistory === 'Y';
      this.documentDownloadTemplateFieldData.completeHistory = res.completeHistory === 'Y';
      this.documentDownloadTemplateFieldData.totalYears = res.totalYears;
      this.documentDownloadTemplateFieldData.isLatestOnTop = res.isLatestOnTop === 'Y';
      this.documentDownloadTemplateFieldData.amendment = res.amendment === 'Y';
      this.documentDownloadTemplateFieldData.approval = res.approval === 'Y';
      this.documentDownloadTemplateFieldData.includeAddlDetails = res.includeAddlDetails === 'Y';
      this.documentDownloadTemplateFieldData.onLastPage = res.onLastPage === 'Y';
      this.documentDownloadTemplateFieldData.footer = res.footer === 'Y';
      this.documentDownloadTemplateFieldData.pageNumber = res.pageNumber === 'Y';
      this.documentDownloadTemplateFieldData.publisherDetails = res.publisherDetails === 'Y';
      this.documentDownloadTemplateFieldData.linkedDocuments = res.linkedDocuments === 'Y';
      this.documentDownloadTemplateFieldData.notes = res.notes === 'Y';

      /* 🔹 NAMES */
      this.documentDownloadTemplateFieldData.coverPageOrSignPageName = res.coverPageOrSignPageName;
      this.documentDownloadTemplateFieldData.includeAddlDetailsName = res.includeAddlDetailsName;
      this.documentDownloadTemplateFieldData.revisionHistoryPageName = res.revisionHistoryPageName;
      this.documentDownloadTemplateFieldData.amendmentPageName = res.amendmentPageName;
      this.documentDownloadTemplateFieldData.approvalPageName = res.approvalPageName;
      this.documentDownloadTemplateFieldData.notesDetail = res.notesDetail;

      this.onCoverPageToggle();
      this.selectBoxForReportLogo();

      this.visibleAddAndEditPopup =
        this.dialog.open(this.addAndEditPopup, { width: '75%', disableClose: true });


    });
  }


  onCoverPageToggle(): void {
    if (this.documentDownloadTemplateFieldData.coverPageOrSign) {
      this.documentDownloadTemplateFieldData.onLastPage = true;
    }
  }



  previousData: any;
  getDmsDocumentDownloadTemplateVwData: any = [];
  qaArray: any = [];
  filteredQaUsersValue: any;
  filteredRepeatIntervalUnit: any;
  positionValue: any = 1;


  refreshGridData() {
    this.getcallMethod();
  }

  addAndEditFunction(data: any): void {


    if (this.hasValidationErrors(data)) {
      this.fieldValidation();
      this.isProcessing = false;
      return;
    }

    const payload = this.buildPayload(data);

    const api$ =
      this.operationFlag === 'ADD'
        ? this.appService.createDmsDocumentDownloadTemplate(payload)
        : this.appService.updateDmsDocumentDownloadTemplate(payload);

    api$.subscribe({
      next: (res: any) => this.handleResponse(res),
      error: () => (this.isProcessing = false)
    });
  }
  private hasValidationErrors(data: any): boolean {
    return (
      (this.visibleEditButton && !data.updateReason) ||
      !data.templateName ||
      (data.notes && (!data.notesDetail || data.notesDetail.trim() === ''))
    );
  }
  private buildPayload(data: any): any {
    return {

      templateId:
        this.operationFlag === 'EDIT' ? Number(data.templateId) : null,

      templateName: data.templateName,
      issuanceType: data.issuanceType,
      issuedTo: data.issuedTo,
      printsTaken: data.printsTaken,
      issuanceReason: data.issuanceReason,

      reportLogoId: data.reportLogoId,
      headerTemplate: data.headerTemplate,
      comments: data.comments,

      coverPageOrSign: this.toYN(data.coverPageOrSign),
      coverPageOrSignPageName: data.coverPageOrSignPageName,

      revisionHistory: this.toYN(data.revisionHistory),
      revisionHistoryPageName: data.revisionHistoryPageName,

      completeHistory: this.toYN(data.completeHistory),
      totalYears: data.completeHistory ? null : Number(data.totalYears),

      isLatestOnTop: this.toYN(data.isLatestOnTop),

      amendment: this.toYN(data.amendment),
      amendmentPageName: data.amendmentPageName,

      approval: this.toYN(data.approval),
      approvalPageName: data.approvalPageName,

      includeAddlDetails: this.toYN(data.includeAddlDetails),
      includeAddlDetailsName: data.includeAddlDetailsName,

      onLastPage: this.toYN(data.onLastPage),
      footer: this.toYN(data.footer),
      pageNumber: this.toYN(data.pageNumber),

      publisherDetails: this.toYN(data.publisherDetails),
      linkedDocuments: this.toYN(data.linkedDocuments),

      notes: this.toYN(data.notes),
      notesDetail: data.notesDetail,

      updateReason: data.updateReason,
      deleteReason: data.deleteReason,
      issueCommit: data.issueCommit || 'N'
    };
  }

  private toYN(value: any): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }



  private handleResponse(response: any) {
    if (response.resultType === 'S') {
      this.getcallMethod();
      this.visibleAddAndEditPopup.close();
    }

    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message: response.result,
        type: response.resultType === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName:
          this.message.breadcrumbData.thirdLevel ??
          this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: response.resultType === 'S' ? 'Success' : 'Error'
    });

    sb.onAction().subscribe(() => sb.dismiss());
    this.isProcessing = false;
  }



  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteDocumentDownloadTemplate: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Document Download Template";
    this.deleteDocumentDownloadTemplate = deleteRowData;
    if (this.documentDownloadTemplateFieldData.deleteReason != undefined) {
      this.documentDownloadTemplateFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteDocumentDownloadTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {

    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        templateId: this.deleteDocumentDownloadTemplate.TEMPLATE_ID,
        templateName: this.deleteDocumentDownloadTemplate.TEMPLATE_NAME,
        deleteReason: this.documentDownloadTemplateFieldData.deleteReason,
      }
      this.appService.deleteDmsDocumentDownloadTemplate(data).subscribe({
        next: (response: any) => {
          if (response.resultType === 'S') {
            this.getcallMethod();
            this.visibleDeletePopup.close();
          }

          const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: response.resultType === 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok'
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: response.resultType === 'S' ? 'Success' : 'Error'
          });

          sb.onAction().subscribe(() => sb.dismiss());
        },
        error: (error) => {

          throw error;
        }
      });

    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.TEMPLATE_ID;
    this.auditTrail.gridName = 'DOCUMENT_DOWNLOAD_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Document Download Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Document Download Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  warningMsg: any;
  okInfo() {
    this.visibleInfoPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  DynamicLabelCall() {

    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (res: any) => {
        this.label = res;

        this.dynamicLabel = this.label.reduce(
          (acc: any, user: any) => {
            acc[user.columnName] = user.changedFieldName;
            return acc;
          },
          {}
        );


      },
      error: () => {

      }
    });

  }


  @Output() valueChange = new EventEmitter<boolean>;
  @Input() documentData: any;
  @Input() isFrom: any;
  @Input() file: File;
  @Input() selectedDocList: any = [];
  @Input() isPrintMode: boolean = false;
  @Input() isOnlyPreviewMode: boolean = false;
  listOfDmsIssuanceTypes: any = [];
  title: any;
  issuanceCopyInvalid: boolean = false;
  docViewer!: DocViewerConfig;
  // In document-download.component.ts
  @ViewChild('viewPopup2', { static: false }) documentViewerPrinterComponent?: DocumentViewerPrinterComponent;
  @ViewChild('viewPopup') documentViewerComponent?: DocumentViewerComponent;        // For app-document-viewer (adjust #viewPopup2 accordingly in template)



  folderId = 0;
  dropdownForHeaderReportTemplate: any = [];
  documentTypeData: any = {};
  editReportLogoId: any;
  ngOnInit(): void {


    this.getcallMethod();

    this.appService
      .getOneQmsOrganizationReportImage()
      .subscribe({
        next: (orgImages: any) => {
          this.organizationReportImageDetails = orgImages;

          this.appService
            .getQmsReportLogoByModuleAndGroupId(
              'DOCS',
              this.folderId
            )
            .subscribe({
              next: (logoData: any) => {
                this.dropDownDataForReportLogo = logoData;
                this.selectBoxForReportLogo();
              },
              error: () => {
              }
            });
        },
        error: () => {

        }
      });
  }



  selectBoxForReportLogo(): void {
    this.reportLogoDropdown = [];

    if (!this.dropDownDataForReportLogo || !this.organizationReportImageDetails) {
      return;
    }

    const reportImageList = this.dropDownDataForReportLogo.reportImageList;

    if (reportImageList === 'Default') {
      this.reportLogoDropdown.push({
        valueExp: '0',
        displayExp: 'Default'
      });
    }
    else if (reportImageList.includes(',')) {
      reportImageList.split(',').forEach((id: string) => {
        const match = this.organizationReportImageDetails.find(
          (img: any) => String(img.reportImageId) === String(id)
        );
        if (match) {
          this.reportLogoDropdown.push({
            valueExp: String(match.reportImageId),
            displayExp: match.reportImageName
          });
        }
      });
    }
    else {
      const match = this.organizationReportImageDetails.find(
        (img: any) => String(img.reportImageId) === String(reportImageList)
      );
      if (match) {
        this.reportLogoDropdown.push({
          valueExp: String(match.reportImageId),
          displayExp: match.reportImageName
        });
      }
    }

    if (this.editReportLogoId) {
      this.documentDownloadTemplateFieldData.reportLogoId = this.editReportLogoId;
    }
  }



  issuanceTypeSearchText: string = '';
  ReportHeaderSearchText: string = '';
  selectedOptionforDownload: any = "Revision History";
  completeHistory: boolean = false;
  documentHistList: any = [];
  savedReportsList: any = [];
  documentIssuanceTypeDropdown: any = [];
  documentIssuanceTypeList: any = [];
  imageIdList: any = [];


  private resetForm(): void {
    this.documentDownloadTemplateFieldData = {
      templateId: null,
      templateName: '',
      issuanceType: null,
      issuedTo: null,
      printsTaken: null,
      issuanceReason: null,
      reportLogoId: null,
      headerTemplate: null,
      comments: null,
      coverPageOrSign: false,
      coverPageOrSignPageName: null,
      revisionHistory: false,
      revisionHistoryPageName: null,
      completeHistory: false,
      totalYears: null,
      amendment: false,
      amendmentPageName: null,
      approval: false,
      approvalPageName: null,
      onLastPage: false,
      footer: false,
      pageNumber: false,
      publisherDetails: false,
      linkedDocuments: false,
      notes: false,
      notesDetail: null,
      updateReason: null,
      deleteReason: null,
      issueCommit: 'N'
    };
  }
  private validateIssuanceCopyField(): boolean {
    if (this.issuanceCopy == null || this.issuanceCopy == undefined || this.issuanceCopy < 1 || Number.isNaN(this.issuanceCopy)) {
      this.issuanceCopyInvalid = true;
      return false;
    }
    this.issuanceCopyInvalid = false;
    return true;
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

}
